import { z } from 'zod';
import { ServiceEventBaseSchema, serviceEventType } from './service.js';
const hydrationEntity = 'hydration';
const hydrationEventType = (eventName) => serviceEventType(hydrationEntity, eventName);
export const HydrationSuccessEventSchema = ServiceEventBaseSchema.merge(z.object({
    type: hydrationEventType('success'),
    hydration: z.object({
        executionArn: z.string(),
        orgIds: z.string().array(),
    }),
}));
